import {combineReducers} from "redux";
import userReducer from "./user";
import resourceReducer from "./resource";
import secondResourceReducer from "./secondResource";
import uiReducer from "./ui";
import downloadReducer from "./download";

const appReducer = combineReducers({
    user: userReducer,
    resource: resourceReducer,
    download: downloadReducer,
    ui: uiReducer,
    secondResource: secondResourceReducer
});

const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        return {
            ui: {},
            user: {},
            resource: {},
            download: {},
            secondResource: {}
        }
    }
    return appReducer(state, action);
};

export default rootReducer;
